import axios from 'axios'

export sendToHubspot = ({ formData, dataConfig, results }) ->
	# Map our fields to the Hubspot fields
	# https://legacydocs.hubspot.com/docs/methods/forms/submit_form

	unless formData and dataConfig
		return console.warn "Didn't send to Hubspot. Missing formData or dataConfig."

	unless process.env.HUBSPOT_PORTAL_ID and process.env.HUBSPOT_FORM_ID
		return console.warn "Didn't send to Hubspot. Missing ENV variables."

	# Get hubspot cookie, if exists
	hubspotCookie = getCookie('hubspotutk')

	# Send Hubspot information about where this submission came from
	hubspotContext =
		# Page URL
		pageUri: window?.location?.href
		# Page title
		pageName: document?.title
	# Only pass hubspot cookie if it exists and not empty string
	hubspotContext.hutk = hubspotCookie if !!hubspotCookie

	# Prepare fields for sending to Hubspot
	hubspotData =
		# Map our fields to the Hubspot form fields
		company: formData.company
		email: formData.email
		firstname: formData.firstname
		lastname: formData.lastname
		job_title_dropdown: formData.role
		website: formData.website
		roi_calculator__has_cdn_: formData.cdn
		roi_calculator__number_of_engineers__contractor_: formData.contractorQty
		roi_calculator__engineer_salary__contractor_: formData.contractorSalary
		roi_calculator__average_conversion_rate: formData.conversionRate
		roi_calculator__average_conversion_value: formData.conversionValue
		roi_calculator__number_of_engineers__fte_: formData.engineerQty
		roi_calculator__engineer_salary__fte_: formData.engineerSalary
		roi_calculator__days_to_add_page_to_web_project: formData.newSitesDaysPerPage
		roi_calculator__pages_per_web_project: formData.newSitesPagesEach
		roi_calculator__new_web_projects_per_year: formData.newSitesPerYear
		roi_calculator__traffic_volume__millions_: formData.trafficVolume
		roi_calculator__results_link: results.shareUrl
		roi_calculator__opt_in_to_marketing: if formData.consentToCommunicate then "Yes" else "No"

	# Convert into an array for sending to Hubspot
	# formatted like: [{name:"firstname", value:"Adam"}]
	fields = Object.keys( hubspotData ).map (key) -> return
		name: key
		value: hubspotData[key]
	# Remove fields with no value
	fields = fields.filter (field) -> field.value?

	# Build the Hubspot request
	hubspotRequest =
		fields: fields
		context: hubspotContext
		legalConsentOptions:
			consent:
				consentToProcess: formData.consentToProcess
				text: formData.consentToProcessLabel

				# Can't include 'communications' in response, because Hubspot will return error
				# if 'subscriptionTypeId' is not included.  Client doesn't know what value to use.
				# communications: [
				# 	{
				# 		value: formData.consentToCommunicate
				# 		subscriptionTypeId: 999
				# 		text: dataConfig.consentToCommunicate?.label
				# 	}
				# ]

	# Send the Hubspot request
	try
		response = await axios
			url: "https://api.hsforms.com/submissions/v3/integration/submit/#{ process.env.HUBSPOT_PORTAL_ID }/#{ process.env.HUBSPOT_FORM_ID }"
			method: 'post'
			headers:
				'Content-Type': 'application/json',
			data: hubspotRequest

	catch error
		console.warn 'Error sending to Hubspot', error

		# One common Hubspot error is "INVALID_EMAIL", where the email field is valid for us
		# but invalid for Hubspot, apparently their validation is more rigorous than ours.
		# If this happens, prevent our submit and show an error.
		throw 'INVALID_EMAIL' if error?.response?.data?.errors?[0]?.errorType == 'INVALID_EMAIL'

# Get cookie value from name
# Usage: `getCookie('hubspotutk')`
export getCookie = (cookieName) ->
	# Text to search for
	name = cookieName + "="

	# Decode the cookie string, to handle cookies with special characters like '$'
	decodedCookies = decodeURIComponent(document.cookie)

	# Split on semicolons into array
	cookies = decodedCookies.split(';')

	# Loop through array, read out each value
	for cookie in cookies

		# Trim leading whitespace
		while (cookie.charAt(0) == ' ')
			cookie = cookie.substring(1)

		# If cookie found, return value.
		if (cookie.indexOf(name) == 0)
			return cookie.substring(name.length, cookie.length)

	# If cookie not found, return empty string.
	return ""
